import * as React from 'react'

import { ProductPageContextInterface } from './types'

export const ProductPageContext = React.createContext<
  ProductPageContextInterface
>({})
